<app-title-bar rootBreadCrumbs="['i18n.core.navigation.reports']" titleText="i18n.domain.reports.device-status.title"></app-title-bar>
<div class="row">
  <app-device-status-form class="col" [form]="filterForm" (searchDTOChanged)="searchReports()"></app-device-status-form>
  <div *ngIf="selectedClient" class="col">
    <button class="btn btn-primary float-end mb-2 refresh-btn" (click)="onRefresh()" title="refresh">
      <span class="e-icons icon-reset"></span>
    </button>
  </div>
</div>

<ng-container *ngIf="selectedClient">
  <ejs-grid #grid
            class="grid-with-footer"
            width="100%"
            rowHeight="38"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            (rowDataBound)="markLastSignalRows($event)"
            [dataSource]="data">
    <e-columns>
      <e-column field="device.name"
                headerText="{{'i18n.domain.reports.device-status.grid.name' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="device.deviceType"
                headerText="{{'i18n.domain.reports.device-status.grid.deviceType' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{formatDeviceType(data.device.deviceType) | translate}}
        </ng-template>
      </e-column>
      <e-column field="device.brand"
                headerText="{{'i18n.domain.reports.device-status.grid.brand' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{formatDeviceBrand(data.device.brand) | translate}}
        </ng-template>
      </e-column>
      <e-column field="device.zone.name"
                headerText="{{'i18n.domain.reports.device-status.grid.zone' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="device.direction"
                headerText="{{'i18n.domain.reports.device-status.grid.direction' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{formatDeviceDirection(data.device.direction) | translate}}
        </ng-template>
      </e-column>
      <e-column field="device.ipAddress"
                headerText="{{'i18n.domain.reports.device-status.grid.ipAddress' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{getDeviceIpAddress(data.device)}}
        </ng-template>
      </e-column>
      <e-column field="device.state"
                headerText="{{'i18n.domain.reports.device-status.grid.state' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{formatDeviceState(data.device.state, data.device) | translate}}
        </ng-template>
      </e-column>
      <e-column field="device.enabled"
                headerText="{{'i18n.domain.reports.device-status.grid.enabled' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{(data.device.enabled ? 'i18n.shared.yes' : 'i18n.shared.no') | translate}}
        </ng-template>
      </e-column>
      <e-column field="device.lastSignal"
                headerText="{{'i18n.domain.reports.device-status.grid.lastSignal' | translate}}"
                type="date"
                format="dd.MM.yyyy HH:mm:ss"
                clipMode="EllipsisWithTooltip">
      </e-column>
    </e-columns>
  </ejs-grid>
  <app-reports-footer (saveClicked)="saveReport($event)"></app-reports-footer>
</ng-container>

